declare var require: any;

import {Environment} from './environment.model';

export const environment: Environment = {
  production: true,
  ekulturPrimusAppID: '06571733-ed99-4a83-92bf-78e64236938a',
  ekulturLoginGatewayURL: 'https://login.ekultur.org',
  ekulturAPIGatewayURL: 'https://apigateway.primus.org',
  plausible: {
    domain: 'online.primus.org',
  },
  version: require('../../package.json').version
};
